export default {
  nav: {
    Down: "Download",
    ReserveGift: "Pre-register for gifts",
    CharacterIntroduction: "Character introduction",
    Gameplay: "Gameplay introduction",
    AttentionFB: "Special recharge offer",
  },
  news: {
    NextPage: "Next Page",
    PrevPage: "Previous Page",
    NextContent: "Next Post",
    PrevContent: "Previous Post",
    Return: "Back",
    ReturnList: "Back to List",
    More: "More",
    None: "gone",
  },
};
